import { render, staticRenderFns } from "./elec-energy-basis-pie.vue?vue&type=template&id=25bb6110&scoped=true&"
import script from "./elec-energy-basis-pie.vue?vue&type=script&lang=js&"
export * from "./elec-energy-basis-pie.vue?vue&type=script&lang=js&"
import style0 from "./elec-energy-basis-pie.vue?vue&type=style&index=0&id=25bb6110&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb6110",
  null
  
)

export default component.exports